<template>
  <div id="bannerView">
    <h3 class="disabled"> BANNER </h3>
      <Slick ref="banenr_slick" class="banner_slider" :options="slickOptions">
        <!-- Banners -->
        <div class="slider_item" v-for="item in banners" :key="`banner_${item.id}`" >
          <article Banner :style="{
            'backgroundImage': `url(${isMobile ? item.img_banner_mobile_url : item.img_banner_url})`}">
            <h4 class="disabled"> {{ item.title }} </h4>
            <div class="slider_wrap">
              <a class="banner_contents statv_wrapper" :href="item.link == ''? '#' : item.link" target="_blank">
                <div class="banner_contents_item"><p v-html="item.sub_title"> </p></div>
                <div class="banner_contents_item"><p> {{item.title}} </p></div>
                <div class="banner_contents_item"><p v-html="item.contents"> </p></div>
              </a>
            </div>
          </article>
        </div>
        
      </Slick>
  </div>
</template>
<script>
import Slick from "vue-slick";
import $ from "jquery";
import "slick-carousel/slick/slick.css";
import moment from "moment";
import _ from "lodash";
import Utils from "@/helpers/utils.js";
import * as Store from '@/store/modules/banner';

export default {
  name: "Banner",
  components: {
    Slick,
  },
  // props: ["isMobile"],
  data() {
    return {
      slickOptions: {
        slidesToshow: 1,
        slidesToScroll: 1,
        speed: 500,
        fade: true,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: true,
        dots: true,
        prevArrow: '<button class="slick-arrow slick-prev"></button>',
        nextArrow: '<button class="slick-arrow slick-next"></button>',
      },
    }
  },
  computed: {
    ...Store.mapState([
      'banners',
    ]),
    isMobile() {
      return Utils.isMobile()
    }
  },
  async created() { 
    await this.getBanners();
    if(this.isMobile) this.slickOptions.fade = false
  },
  beforeDestroy() {
    if (this.$refs.banenr_slick) {
        this.$refs.banenr_slick.destroy();
    }
  },
  updated() {
    this.$nextTick(()=> {
      if(this.$refs.banenr_slick) {
        this.$refs.banenr_slick.create(this.slickOptions);
      }
    })
  },
  beforeUpdate() {
    if (this.$refs.banenr_slick) {
        this.$refs.banenr_slick.destroy();
    }
  },
  methods: {
    ...Store.mapActions([
      'getBanners',
    ]),
    move(link) {
      if(link !== "") window.open(link,'_blank')
    },
    // 배너 하단 페이지 구성
    customPaging(event, slick, currentSlide, nextSlide) {
      let $status = $('.slick-dots');
      let i = (currentSlide ? currentSlide : 0) + 1;
      let n = (i ==slick.slideCount ? 0 : i) + 1;
      $status.html(
          `
          <div class="slick-page">
          <span>0${i}</span><hr/><span>0${n}</span>
          </div>
          `
      );
    },
  }
}
</script>
<style lang="less">
#bannerView {
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  .banner_slider {
    position: relative;
    z-index: 1;
    width: 1920px;
    height: 100%;
    overflow-x: hidden;
    // transition: left 2s;
    .slider_item {
      width: 100%;
      height: 100%;
      article[Banner] {
        position: relative;
        width: 100%;
        height: 100%;
        background-color:rgba(0, 0, 0, 0);
        background-size: 1920px 100%;
        background-position: center;
        background-repeat: no-repeat;
        //Gradient Wrapper
        .slider_wrap {
          width: 100%;
          height: 550px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        //Banner section
        .banner_contents {
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: left;
          height: 100%;
          text-decoration: none;
          cursor: pointer;
          // margin:auto;
          .banner_contents_item {
            display: flex;
            text-align: left;
            word-break: break-all;
            p {
              width: auto;
              height: auto;
              align-self: baseline;
              letter-spacing: 0;
              line-height: normal;
              color: #ffffff;
              font-size: 26px;
              margin-bottom: 5px;
              font-weight: 400;
            }
            &:first-child {
              //SUB TITLE
              p {
                font-weight: 900;
              }
            }
            &:nth-child(2) {
              //TITLE
              p {
                font-size: 44px;
                font-weight: 900;
                margin-bottom: 24px;
              }
            }
          }
        }
      }
    }
    .slick-next {
      background-image: url("~@/assets/image/home/arrow_white_right.png");
      background-repeat: no-repeat;
      background-size: 150%;
      background-position: center;
      right: -1200px;
      left: 0;
      // move position as much as .slick-page's width (19rem) + 1rem
    }

    .slick-prev {
      background-image: url("~@/assets/image/home/arrow_white_left.png");
      background-repeat: no-repeat;
      background-size: 150%;
      background-position: center;
      left: -1200px;
      right: 0;
      // move position as much as .slick-page's width (19rem) + 1rem
    }

    .slick-arrow {
      display: block;
      width: 36px;
      height: 180px;
      border: none;
      padding: 0;
      z-index: 1;
      top: 0;
      bottom: 0;
      margin: auto;
      cursor: pointer;
      position: absolute;
      background-color:rgba(0, 0, 0, 0);
    }
    //slick page style
    .slick-dots {
        list-style: none;
        position: absolute;
        bottom: 10px;
        display: flex;
        justify-content: center;
        list-style-type: none;
        left: 50%;
        transform: translateX(-50%);
        padding: 0;
        margin: 0 auto;
        li {
            margin: 0 7px;
            height: 100%;
        }
        button {
            display: block;
            width: 14px;
            height: 14px;
            padding: 0;
            border: 1px solid #ff0043;
            border-radius: 100%;
            // background: radial-gradient(#00bdd6, #00bdd6b8, #00bdd661);
            background: #FFFFFF;
            text-indent: -9999px;
            padding: 0;
            cursor: pointer;
        }
        li.slick-active button {
          border: 1px solid #FFFFFF;
          background: #ff0043;
        }
    }
  }
}

//Mobile View
.m #bannerView {
  .banner_slider {
    width: 765px;
    .slider_item {
      article[Banner] {
        background-size: 765px 100%;
        .slider_wrap {
          height: 800px;
        }
        .banner_contents {
          justify-content: flex-start;
          padding-top: 98px;
          height: 100%;
          .banner_contents_item {
            p {
              font-size: 38px;
              margin-bottom: 12px;
              color: #ff0043;
            }
            &:nth-child(2) {
              p {
                font-size: 64px;
              }
            }
          }
        }
      }
    }
    .slick-dots {
      button {
        width: 20px;
        height: 20px;
        margin: 5px;
      }
    }
  }
}

</style>